import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { Header, Sidebar } from 'src/component'
import access from 'src/utils/localAccess'
import './customer-support.scss'
import { appSettings } from 'src/provider/config/constant'

export const CustomerSupportRoutes = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info, recoverStatesData, logout} = useContext(AppInfoContext)
    const [isAuth, setIsAuth] = useState(!!info.token)

    useEffect(() => {
        recoverStatesData()
        handleAuth()
        access.setNavigationAccess(navigate)
        access.setLogoutHandler(logout)
    }, [])

    // TO GET NEW ACCESS_TOKEN AND REFRESH-TOKEN
    useEffect(() => {
        if (info.token) API.runBackgroundJob('get-refresh-token', appSettings.TOKEN_REFRESH_TIME)
    }, [info.refreshTokenTrigger])

    async function handleAuth () {
        const authToken = await localStorage.getItem('token')
        if (authToken) setIsAuth(!!authToken)
        else logout()
    }
    
    return (
        <>
            { isAuth &&
                <div className="customer-support-container">
                    <Header />
                    <Sidebar />
                    <div className="customer-support-modules">
                        <Outlet/>
                    </div>
                </div>
            }
        </>
    )
}

export default {
    routeProps: {
        path: 'customer-support',
        element: <CustomerSupportRoutes/>
    },
    name: 'Customer Support'
}